import React from 'react';
import { FaMicrosoft, FaWindows, FaServer, FaDatabase, FaShieldAlt, FaCloud } from 'react-icons/fa';

const Products: React.FC = () => {
  const products = [
    {
      icon: <FaMicrosoft className="text-5xl text-blue-500" />,
      title: 'Microsoft 365',
      description: 'Complete productivity suite including Word, Excel, PowerPoint, Teams, and more for seamless collaboration.',
      features: ['Business Basic', 'Business Standard', 'Business Premium', 'Enterprise Plans'],
    },
    {
      icon: <FaWindows className="text-5xl text-blue-500" />,
      title: 'Windows Licensing',
      description: 'Volume licensing for Windows 10/11 Pro, Enterprise, and Server editions for businesses of all sizes.',
      features: ['Windows 11 Pro', 'Windows 11 Enterprise', 'Volume Licensing', 'Upgrade Paths'],
    },
    {
      icon: <FaServer className="text-5xl text-blue-500" />,
      title: 'Windows Server',
      description: 'Enterprise-grade server solutions including Windows Server 2022, CALs, and Remote Desktop Services.',
      features: ['Server 2022 Standard', 'Server 2022 Datacenter', 'CAL Licensing', 'RDS Solutions'],
    },
    {
      icon: <FaCloud className="text-5xl text-blue-500" />,
      title: 'Azure Services',
      description: 'Cloud infrastructure services including virtual machines, storage, networking, and managed services.',
      features: ['Virtual Machines', 'Azure Storage', 'Azure AD', 'Hybrid Solutions'],
    },
    {
      icon: <FaDatabase className="text-5xl text-blue-500" />,
      title: 'SQL Server',
      description: 'Database solutions with SQL Server licensing for data management and business intelligence.',
      features: ['SQL Server Standard', 'SQL Server Enterprise', 'Azure SQL', 'Data Analytics'],
    },
    {
      icon: <FaShieldAlt className="text-5xl text-blue-500" />,
      title: 'Security Solutions',
      description: 'Comprehensive security products including Microsoft Defender, Intune, and Azure Security Center.',
      features: ['Microsoft Defender', 'Azure Security', 'Intune MDM', 'Compliance Tools'],
    },
  ];

  return (
    <section id="products" className="py-20 bg-gray-900 text-white">
      <div className="container mx-auto px-4">
        {/* Section Header */}
        <div className="text-center mb-16">
          <span className="text-orange-400 font-semibold text-lg">Our Products</span>
          <h2 className="text-4xl md:text-5xl font-bold mt-2 mb-4">
            Software & Licensing Solutions
          </h2>
          <p className="text-gray-400 max-w-2xl mx-auto text-lg">
            As a Microsoft Silver Certified Partner, we offer genuine Microsoft products
            and volume licensing solutions at competitive prices.
          </p>
        </div>

        {/* Products Grid */}
        <div className="grid md:grid-cols-2 lg:grid-cols-3 gap-8">
          {products.map((product, index) => (
            <div
              key={index}
              className="bg-gray-800 rounded-2xl p-8 hover:bg-gray-750 transition-all duration-300 transform hover:-translate-y-2 border border-gray-700 hover:border-blue-500"
            >
              <div className="mb-6">{product.icon}</div>
              <h3 className="text-2xl font-bold mb-4">{product.title}</h3>
              <p className="text-gray-400 mb-6">{product.description}</p>
              <ul className="space-y-2 mb-6">
                {product.features.map((feature, idx) => (
                  <li key={idx} className="flex items-center text-gray-300">
                    <span className="w-2 h-2 bg-orange-400 rounded-full mr-3"></span>
                    {feature}
                  </li>
                ))}
              </ul>
              <a
                href="#contact"
                className="inline-block text-blue-400 hover:text-orange-400 font-semibold transition-colors duration-300"
              >
                Get Quote →
              </a>
            </div>
          ))}
        </div>

        {/* Partner Badge */}
        <div className="mt-16 text-center">
          <div className="inline-block bg-gray-800 rounded-2xl px-8 py-6 border border-gray-700">
            <div className="flex items-center justify-center space-x-4">
              <img
                src="https://upload.wikimedia.org/wikipedia/commons/thumb/4/44/Microsoft_logo.svg/512px-Microsoft_logo.svg.png"
                alt="Microsoft Logo"
                className="h-12"
              />
              <div className="text-left">
                <p className="text-gray-400 text-sm">Authorized</p>
                <p className="text-xl font-bold">Microsoft Silver Partner</p>
              </div>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
};

export default Products;
